import { Observable } from 'rxjs';
import { createContext } from 'mobx-keystone';
import { ApiClient } from 'utils/api-client';

export const apiCtx = createContext<ApiClient>(new ApiClient());
export const login$Ctx = createContext<Observable<boolean>>();
